import { BehaviorParameters } from 'rangeConfig/@types';

const enableUndoRedo = ({ coreApi }: BehaviorParameters) => {
  coreApi.history.enable();
};

export default enableUndoRedo;
